// Safari のための Polyfill

interface Window {
  AudioContext: {};
  webkitAudioContext: {};
}

window.AudioContext = window.AudioContext || window.webkitAudioContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/polyfill/AudioContext.ts